/**
 * Check if the current domain is authorized to access booking features
 * @returns {boolean} true if domain is localhost or any subdomain of taxiora.fr
 */
export const shouldAllowBookings = () => {
  const has_booking = process.env.REACT_APP_HAS_BOOKING;

  console.log({has_booking});

  return has_booking == 'true';
}; 